import React, { useEffect } from 'react';
import './App.css';
import { selectUser, login, logout } from './features/userSlice.js';
import Header from './Header';
import Sidebar from './Sidebar.js';
import Feed from './Feed.js';
import { useDispatch, useSelector } from 'react-redux';
import Login from './Login.js'
import { auth } from "./firebase";
import Widgets from './Widgets.js';

function App() {
  const user = useSelector(selectUser); // <-- simplified
  const dispatch = useDispatch();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((userAuth) => {
      if (userAuth) {
        dispatch(
          login({
            email: userAuth.email,
            uid: userAuth.uid,
            displayName: userAuth.displayName,
            photoUrl: userAuth.photoURL,
          })
        );
      } else {
        dispatch(logout());
      }
    });

    // Cleanup subscription on unmount
    return unsubscribe;
  }, [dispatch]);

  return (
    <div className="app">
      <Header/>
      {!user ? (
        <Login />
      ) : (
        <div className='app_body'>
          <Sidebar />
          <Feed />
          <Widgets />
        </div>
      )}
    </div>
  );
}

export default App;
